document.addEventListener('DOMContentLoaded', function () {
  // Loading state when clicking the button
  var buttonWrappers = document.querySelectorAll('.button-with-spinner');
  buttonWrappers.forEach(function (buttonWrapper) {
    var button = buttonWrapper.querySelector('.submit-button');
    var spinner = buttonWrapper.querySelector('.loading-spinner');
    var buttonText = buttonWrapper.querySelector('.button-text');

    button.addEventListener('click', function (event) {
      // Prevent multiple submissions
      if (button.disabled) {
        return;
      }

      // Set button to disabled and show spinner
      button.disabled = true;
      if (spinner) {
        spinner.classList.remove('tw-hidden');
      }
      if (buttonText) {
        buttonText.style.visibility = 'hidden';
      }

      // Simulate form submission or perform actual form submission here
      setTimeout(function () {
        spinnerStop(buttonWrapper);
      }, 2000); // Remove timeout when integrating real submission logic
    });
  });
});

// Stop spinner function to reset the button state
function spinnerStop(buttonWrapper) {
  var spinner = buttonWrapper.querySelector('.loading-spinner');
  var buttonText = buttonWrapper.querySelector('.button-text');
  var button = buttonWrapper.querySelector('.submit-button');

  if (spinner && buttonText && button) {
    spinner.classList.add('tw-hidden');
    buttonText.style.visibility = 'visible';
    button.disabled = false; // Enable the button again
  }
}

var defDate = {};
var disableFlag = {};
var itemErrors = {};
var vendorPath = {};

function itemErrorSet(line, errorText) {
  itemErrors[line] = errorText;
  localStorage.setItem("lineItemErrors", JSON.stringify(itemErrors));
}

var navigationEntries = window.performance.getEntriesByType("navigation");
if (navigationEntries.length > 0 && navigationEntries[0].type === "navigate") {
  // ページが初めて読み込まれた場合の処理
  localStorage.removeItem("saveData");
  localStorage.removeItem("disableFlag");
  localStorage.removeItem("lineItemErrors");
}

function disableFlagSet(vendor, type) {
  if (!disableFlag[vendor]) {
    disableFlag[vendor] = {};
  }
  disableFlag[vendor][type] = true;
  localStorage.setItem("disableFlag", JSON.stringify(disableFlag));
}

function disableFlagRemove(vendor, type) {
  if (!disableFlag[vendor]) {
    disableFlag[vendor] = {};
  }
  disableFlag[vendor][type] = false;
  localStorage.setItem("disableFlag", JSON.stringify(disableFlag));
}

function isVendorDisabled(vendor) {
  if (disableFlag.hasOwnProperty(vendor)) {
    for (let type in disableFlag[vendor]) {
      if (disableFlag[vendor][type]) {
        return true;
      }
    }
  }
  return false;
}

function submitButtonAdjustment() {
  $("form").each(function () {
    var vendorHandle = $(this).data("vendor-handle");
    if (isVendorDisabled(vendorHandle)) {
      $(this).find('button[id*="send-btn"]').prop("disabled", true);
    } else {
      $(this).find('button[id*="send-btn"]').prop("disabled", false);
    }
  });
}


var errorStyle =
  "border: 1px solid #EF4444; background-color: #FEE2E2; font-size: 1.4rem; padding: 1rem;";

//
// オーバーレイ関連
//

// オーバーレイを表示する関数
window.showOverlay = function() {
  var overlay = document.getElementById("overlay");
  if (!overlay) {
    return;
  }

  overlay.classList.add("is-show");
  $("#cart-wrap input").prop("disabled", true);
  $("#cart-wrap select").prop("disabled", true);
  $("#cart-wrap button").prop("disabled", true);
}

// オーバーレイを非表示にする関数
window.hideOverlay = function() {
  var overlay = document.getElementById("overlay");
  if (!overlay) {
    return;
  }

  overlay.classList.remove("is-show");
  $("#cart-wrap input").prop("disabled", false);
  $("#cart-wrap select").prop("disabled", false);
  $("#cart-wrap button").prop("disabled", false);
  submitButtonAdjustment();
}

// ページの読み込みが完了したら、オーバーレイを非表示にする
window.addEventListener("load", function () {
  window.hideOverlay();
});

// Fetch and store the cart data from the cart API
window.fetchAndStoreCartData = async function() {
  const cartEndpoint = `/cart.json`; // Adjust as necessary
  try {
    const response = await fetch(cartEndpoint);
    const cartData = await response.json();
    // Process and structure cartData as needed
    const structuredCartData = processCartData(cartData);
    if (
      cartData.items.length > 0
      && typeof window.addStoredCartDataIfEmpty === 'function'
    ) {
      window.addStoredCartDataIfEmpty();
    }
    localStorage.setItem('MULTI_SUPPLIERS_CART_TMP_ITEMS', JSON.stringify(structuredCartData));
    return cartData;
  } catch (error) {
    console.error('Error fetching cart data:', error);
  }
}

// function to process and structure the cart data
function processCartData(cartData) {
  return cartData.items.map(item => ({
    variantId: item.id,
    quantity: item.quantity,
    vendor: item.vendor,
    properties: item.properties || {},
    sellingPlanId: item.selling_plan ? `gid://shopify/SellingPlan/${item.selling_plan.id}` : null
  }));
}

// Local Storageに保存されたMULTI_SUPPLIERS_CART_TMP_ITEMSを取得して、引数のvendorの商品を除外してLocal Storageに保存
function removeVendorFromCart(vendor) {
  const storedCart = JSON.parse(localStorage.getItem('MULTI_SUPPLIERS_CART_TMP_ITEMS')) || [];
  const updatedCart = storedCart.filter(item => item.vendor !== vendor);
  localStorage.setItem('MULTI_SUPPLIERS_CART_TMP_ITEMS', JSON.stringify(updatedCart));
}

function recordCheckoutResumeEvent(stage, details) {
  if (window.checkoutResumeDebug) {
    window.checkoutResumeDebug.record(stage, details);
  }
}

// Modify the checkout submission to exclude certain vendors
async function cartSubmitted(vendor, options) {
  options = options || {};

  console.log('cartSubmitted called with vendor:', vendor);

  const isUserLoggedIn = window.ikyuCustomerLoggedIn === true;
  const isResumeAfterLogin = options.resumeAfterLogin === true;
  const resumeState = window.checkoutResumeState;
  let resumeIntentPrepared = false;

  if (!isUserLoggedIn && resumeState) {
    resumeIntentPrepared = resumeState.prepare(vendor);
    recordCheckoutResumeEvent('resume_intent_prepared', {
      stored: resumeIntentPrepared,
      vendorPresent: typeof vendor === 'string' && vendor.trim().length > 0,
    });
  }

  function handleSubmissionFailure(errorName) {
    if (resumeState) {
      if (isResumeAfterLogin) {
        resumeState.markFailed();
      } else if (resumeIntentPrepared) {
        resumeState.clear();
      }
    }

    if (isResumeAfterLogin) {
      recordCheckoutResumeEvent('auto_resume_failed', {
        error: errorName || 'CheckoutCreateError',
        source: 'cart_functions',
      });
    }

    return false;
  }

  const storefrontAccessToken = window.ikyuUrls?.storefrontAccessToken;
  console.log('Storefront Access Token:', storefrontAccessToken);
  
  try {
    var lineItems = await getLineItemsByVendor(vendor);
    console.log('Line Items retrieved:', lineItems);
    
    if (lineItems.length > 0) {
      console.log('Creating checkout session...');

      const lineItemsToAdd = lineItems.map(item => ({
        merchandiseId: item.variantId,
        quantity: item.quantity,
        attributes: Array.isArray(item.customAttributes) ? item.customAttributes : [],
        sellingPlanId: item.sellingPlanId
      }));

      const storedCartDataString = localStorage.getItem('MULTI_SUPPLIERS_CART_TMP_ITEMS');
      const cartAttributes = [];
      let remainingCartDataString = null;

      if (storedCartDataString && storedCartDataString.length > 0) {
        try {
          const parsedCartData = JSON.parse(storedCartDataString);
          const remainingCartData = parsedCartData.filter(item => item.vendor !== vendor);
          remainingCartDataString = JSON.stringify(remainingCartData);
          console.log('Number of unpaid items from other stores:', remainingCartData.length);
          cartAttributes.push({
            key: 'cart_data',
            value: remainingCartDataString
          });
        } catch (error) {
          console.error('Invalid cart data format, skipping attribute storage:', error);
        }
      }

      // 商品とCart属性を初期入力へ含め、1回のmutationでCheckout URLまで生成する。
      const cartCreateMutation = `
        mutation cartCreate($input: CartInput!) {
          cartCreate(input: $input) {
            cart {
              id
              checkoutUrl
              attributes {
                key
                value
              }
            }
            userErrors {
              field
              message
            }
          }
        }
      `;
      
      const cartResponse = await fetch(`/api/2023-10/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
        },
        body: JSON.stringify({
          query: cartCreateMutation,
          variables: {
            input: {
              attributes: cartAttributes,
              lines: lineItemsToAdd
            }
          },
        }),
      });
      console.log('Cart Create Response Status:', cartResponse.status);

      if (!cartResponse.ok) {
        console.error('Cart creation HTTP error:', cartResponse.status);
        return handleSubmissionFailure('CartCreateHttpError');
      }

      let cartResponseData = null;
      try {
        cartResponseData = await cartResponse.json();
        console.log('Cart Create Data:', cartResponseData.data);
      } catch (error) {
        console.error('Error parsing cartCreate response:', error);
        return handleSubmissionFailure('CartCreateParseError');
      }

      if (cartResponseData.errors) {
        console.error('GraphQL errors in cart creation:', cartResponseData.errors);
        return handleSubmissionFailure('CartCreateGraphqlError');
      }

      const cartCreatePayload = cartResponseData?.data?.cartCreate;
      if (cartCreatePayload?.userErrors?.length > 0) {
        const errorMessages = cartCreatePayload.userErrors.map(error => error.message);
        const cartItemsElement = document.querySelector('cart-items');

        if (cartItemsElement && cartItemsElement.__x) {
          cartItemsElement.__x.$data.showError = true;
          cartItemsElement.__x.$data.errorMessages = errorMessages;
        }

        return handleSubmissionFailure('CartCreateUserError');
      }

      const cartCheckoutUrl = cartCreatePayload?.cart?.checkoutUrl;
      if (!cartCheckoutUrl) {
        console.error('Checkout URL is undefined.');
        return handleSubmissionFailure('CheckoutUrlMissing');
      }

      const storedCartDataAttribute = cartCreatePayload.cart.attributes?.find(
        attribute => attribute.key === 'cart_data'
      );
      if (cartAttributes.length > 0 && !storedCartDataAttribute) {
        console.warn('cart_data attribute not found in cartCreate response');
      }

      if (remainingCartDataString !== null) {
        localStorage.setItem('MULTI_SUPPLIERS_CART_TMP_ITEMS', remainingCartDataString);
      }

      console.log('Checkout URL:', cartCheckoutUrl);
      
      const redirectUrl = cartCheckoutUrl.replace(/https:\/\/(.*?)\.myshopify\.com/, "https://" + window.location.hostname);
      console.log('Redirecting to:', redirectUrl);

      // 未ログインの場合はログインゲート(/pages/checkout-login)を経由する
      if (window.checkoutResumeDebug) {
        window.checkoutResumeDebug.record('cart_checkout_created', {
          hostType: window.checkoutResumeDebug.classifyUrl(cartCheckoutUrl),
          loggedIn: isUserLoggedIn,
          source: 'cart_functions',
        });
      }

      if (!isUserLoggedIn) {
        // ゲスト購入用に、Storefront API が返した checkoutUrl をログインゲートへ渡す。
        // ログインを選んだ場合はゲート側でこのURLを破棄し、認証後にCartを再生成する。
        let resumeStorageError = 'none';
        let resumeStored = true;
        try {
          localStorage.setItem('checkoutUrl2', cartCheckoutUrl);
        } catch (error) {
          resumeStored = false;
          resumeStorageError = error?.name || 'StorageWriteError';
        }

        if (window.checkoutResumeDebug) {
          window.checkoutResumeDebug.record('cart_resume_saved', {
            error: resumeStorageError,
            hostType: window.checkoutResumeDebug.classifyUrl(cartCheckoutUrl),
            source: 'cart_functions',
            stored: resumeStored,
          });
        }

        window.location.href = '/pages/checkout-login?return_to=' + encodeURIComponent(cartCheckoutUrl);
      } else {
        if (isResumeAfterLogin) {
          recordCheckoutResumeEvent('auto_resume_checkout_created', {
            hostType: window.checkoutResumeDebug
              ? window.checkoutResumeDebug.classifyUrl(cartCheckoutUrl)
              : 'unknown',
            loggedIn: true,
            source: 'cart_functions',
          });
        }

        if (resumeState) {
          resumeState.clear();
          resumeState.clearLegacyCheckoutState();
        }

        window.location.href = redirectUrl;
      }

      return true;
    } else {
      console.log("指定されたベンダーの商品が見つかりません。");
      return handleSubmissionFailure('VendorItemsMissing');
    }
  } catch (error) {
    console.error('Error in cartSubmitted:', error);
    return handleSubmissionFailure(error?.name || 'CheckoutCreateError');
  }
}

// 指定されたベンダーの商品リストを取得
async function getLineItemsByVendor(vendor) {
  try {
    const data = await window.fetchAndStoreCartData();
    const lineItems = []; // Storefront APIに合わせた形式のアイテム情報を格納する配列

    data.items.forEach((item) => {
      if (item.vendor === vendor) {
        // 除外したいキーの配列
        const excludeKeys = [
          // 除外したいキーはここに追加
        ];
        // item.properties から excludeKeys に含まれるキーと値が空のものを省略して customAttributes 配列を作成
        const customAttributes = Object.keys(item.properties || {}).filter(key =>
          !excludeKeys.includes(key) && item.properties[key] // 値が空でないこともチェック
        ).map(key => ({
          key: key,
          value: String(item.properties[key])
        }));

        lineItems.push({
          variantId: btoa(`gid://shopify/ProductVariant/${item.variant_id}`), // Base64エンコードされたグローバルID
          quantity: item.quantity,
          customAttributes: customAttributes, // カスタム属性を追加
          sellingPlanId: item.selling_plan_allocation ? `gid://shopify/SellingPlan/${item.selling_plan_allocation.selling_plan.id}` : null
        });
      }
    });
    console.log('lineItems:', lineItems);
    return lineItems;
  } catch (error) {
    console.error('Error fetching cart data:', error);
    return [];
  }
}

// 他の関数もグローバルスコープに定義
window.removeVendorFromCart = function(vendor) {
  const storedCart = JSON.parse(localStorage.getItem('MULTI_SUPPLIERS_CART_TMP_ITEMS')) || [];
  const updatedCart = storedCart.filter(item => item.vendor !== vendor);
  localStorage.setItem('MULTI_SUPPLIERS_CART_TMP_ITEMS', JSON.stringify(updatedCart));
};

async function resumeCheckoutAfterLogin(options) {
  options = options || {};

  var resumeState = window.checkoutResumeState;
  var canResumeOnCurrentPage = options.allowAccount === true
    ? resumeState && resumeState.getPendingLogin() !== null
    : resumeState && resumeState.isResumeCartRequest();

  if (
    !resumeState
    || window.ikyuCustomerLoggedIn !== true
    || !canResumeOnCurrentPage
  ) {
    return false;
  }

  var pendingResume = resumeState.beginResume();
  if (!pendingResume) {
    recordCheckoutResumeEvent('auto_resume_failed', {
      error: 'ResumeStateMissing',
      source: 'cart_functions',
    });
    return false;
  }

  recordCheckoutResumeEvent('auto_resume_started', {
    attempts: pendingResume.attempts,
    loggedIn: true,
    vendorPresent: true,
  });

  try {
    if (typeof window.showOverlay === 'function') {
      window.showOverlay();
    }

    var submitted = await cartSubmitted(pendingResume.vendor, {
      resumeAfterLogin: true,
    });

    if (submitted === false && typeof window.hideOverlay === 'function') {
      window.hideOverlay();
    }

    return submitted !== false;
  } catch (error) {
    resumeState.markFailed();
    recordCheckoutResumeEvent('auto_resume_failed', {
      error: error?.message || error?.name || 'AutoResumeError',
      source: 'cart_functions',
    });

    if (typeof window.hideOverlay === 'function') {
      window.hideOverlay();
    }

    return false;
  }
}

window.resumeCheckoutAfterLogin = resumeCheckoutAfterLogin;
window.addEventListener('load', function () {
  resumeCheckoutAfterLogin();
});
